import { RootState } from 'store';

const FormDefaultsState = (state: RootState) => state.main.formDefaults;

export const selectFormDefaults = (state: RootState) => FormDefaultsState(state).rows;
export const selectFormDefaultsLoading = (state: RootState) => FormDefaultsState(state).loading;
export const selectFormDefaultsError = (state: RootState) => FormDefaultsState(state).error;
